var _defs, _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRelaiblehomeswhite01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-1,.cls-2,.cls-3{stroke:#fff;stroke-miterlimit:10;}.cls-1,.cls-2{stroke-width:2px;}.cls-2,.cls-3{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "24.38 32.46 24.38 74.14 76.07 74.14 76.07 32.46 50.23 10.26 24.38 32.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "45.28 32.46 45.28 74.14 96.96 74.14 96.96 32.46 71.12 10.26 45.28 32.46"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5",
    "data-name": "Layer 5"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "14.13 34.65 50.23 2.96 60.97 11.89 72 2.96 108.15 34.65"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "29.46 74.14 29.46 53.48 40.2 53.48 40.2 74.14"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "81.57 74.14 81.57 53.48 92.31 53.48 92.31 74.14"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.76 87.38 19.95 113.74 35.19 109.23 20.98 82.87 6.76 87.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.42,105.28s5.55-6.54,16.15-2.4,19.64,8.14,29.85.51L91,98l16.67-10.86s.13-12-20.42,3.23L77,93.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.32,86.57l9.44-5.69S51.46,76.1,61,85.41l11.51,3.1s8,3.94,2.58,7.78l-15.9-1.06-9.56-4"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M61.12,49.59s2.36-6.73,8.52-2.58S61.12,59.9,61.12,59.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M61.16,49.59S58.81,42.86,52.64,47,61.16,59.9,61.16,59.9"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelaiblehomeswhite01);
export default __webpack_public_path__ + "static/media/relaible homes white-01.f6e2c8320d47cab1f1193ce502388bee.svg";
export { ForwardRef as ReactComponent };